module.exports = __webpack_public_path__ + "img/rec-02.cfe6f406.jpg";